import type { CallAudioOutputKind } from '../../../services/voice-call/native-audio-route'

/**
 * In-call route picker / chip labels.
 *
 * Android reports the phone *model* (`Pixel 10 Pro XL`) as
 * `AudioDeviceInfo.getProductName()` for BOTH the builtin earpiece and the
 * loudspeaker, so a naive `device.name` dump shows the same string twice.
 * Builtins always get a functional label; real device names are kept only for
 * earbuds / car / wired hardware.
 */
export function displayNameForAudioRoute(
  kind: CallAudioOutputKind | string,
  name?: string | null,
): string {
  if (kind === 'earpiece') return 'Earpiece'
  if (kind === 'speaker') return 'Speaker'
  const trimmed = (name ?? '').trim()
  if (trimmed && trimmed.toLowerCase() !== kind) return trimmed
  switch (kind) {
    case 'bluetooth':
      return 'Bluetooth'
    case 'wired':
      return 'Headphones'
    case 'car':
      return 'Car'
    default:
      return trimmed || 'Audio'
  }
}
